import axios from "axios";
import React, { useEffect, useState } from "react";
import ScrollTable from "../../ScrollTable";
import TransactionRow from "./TransactionRow";

export default function StripeActivity() {
  const [payouts, setpayouts] = useState([]);
  const [page, setpage] = useState(1);
  const [lastPayout, setlastPayout] = useState(null);
  const [fistPayout, setFistPayout] = useState(null);
  const getPayouts = async () => {
    try {
      let res = await axios.get(
        `/api/stripe/payouts/${fistPayout}/${lastPayout}/${page}`
      );
      if (res.data.success) {
        setpayouts(res.data.data);
        setFistPayout(res.data.data[0].id);
        setlastPayout(res.data.data[res.data.data.length - 1].id);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getPayouts();
  }, [page]);

  return (
    <div>
      <ScrollTable className="sales-table-wrap">
        <table className="sales-table">
          <tr className="crm_table_row">
            <th style={{ width: "30px" }}>S.No</th>
            <th style={{ width: "200px" }}>ID</th>
            <th style={{ width: "150px" }}>Date</th>
            <th style={{ width: "150px" }}>Amount(EUR)</th>
            {/* <th style={{ width: "60px" }}>Status</th> */}
            <th style={{ width: "900px" }}>Payments</th>
          </tr>
          {payouts &&
            payouts.length > 0 &&
            payouts.map((pay, i) => (
              <tr className="" key={pay.id}>
                <td>{i + 1}</td>
                <td>{pay.id}</td>
                <td>
                  {new Date(pay.arrival_date * 1000).toLocaleDateString()}
                </td>
                <td style={{ fontWeight: 600 }}> {pay.amount / 100}</td>
                {/* <td> {pay.status}</td> */}
                <td>
                  <table>
                    <tr className="crm_table_row">
                      <th style={{ width: "100px" }}>Date</th>
                      <th style={{ width: "200px" }}>Desc</th>
                      <th style={{ width: "100px" }}>Amount(EUR)</th>
                      <th style={{ width: "100px" }}>Fees</th>
                      <th style={{ width: "100px" }}>Net</th>
                      <th style={{ width: "100px" }}>Invoice</th>
                      <th style={{ width: "100px" }}>Customer</th>
                    </tr>
                    {pay.payments.map(
                      (pm) =>
                        pm.description !== "STRIPE PAYOUT" && (
                          <TransactionRow pm={pm} key={pm.id} />
                        )
                    )}
                  </table>
                </td>
              </tr>
            ))}
        </table>
      </ScrollTable>
        <div style={{ gap: "20px" }} className="mt-24 d-flex">
          <p className="pointer fw-6" onClick={() => setpage(1)}>
            Start
          </p>

          {page !== 1 && (
            <p
              className="pointer fw-6"
              onClick={() => {
                setlastPayout(null);
                setpage(page - 1);
              }}
            >
              {"<"} Back{" "}
            </p>
          )}

          <p
            className="pointer fw-6"
            onClick={() => {
              setFistPayout(null);
              setpage(page + 1);
            }}
          >
            Next {">"}
          </p>
        </div>
    </div>
  );
}
